export default __webpack_public_path__ + "static/media/blogitem3.0ada6247.png";